import { flip } from '@floating-ui/react';
export const useFlip = enabled => {
  const flipMiddleware = flip({
    mainAxis: enabled,
    crossAxis: false
  });
  return {
    flipMiddleware
  };
};